module.exports = __webpack_public_path__ + "img/coins2-red.2d8343f0.svg";